/**
 * 우 패널 슬롯 컨텍스트 (DESIGN §8.6.8).
 *
 * 컴포넌트와 같은 파일에 두면 fast refresh 가 깨져서 분리했다.
 * 값은 셸이 만든 `<aside>` DOM 노드이고, `SidePanel` 이 여기로 portal 한다.
 */

import { createContext } from 'react'

export const SideSlotCtx = createContext<HTMLElement | null>(null)
